/**
 * Кнопка.
 *
 * Вариант выбирается по смыслу действия, а не по цвету: primary —
 * единственное главное действие экрана, accent — переход к покупке,
 * quiet — второстепенное.
 */
import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './Button.module.css';

type Variant = 'primary' | 'accent' | 'quiet' | 'onHero';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: Variant;
  size?: 'm' | 's';
  block?: boolean;
}

export function Button({
  children,
  variant = 'primary',
  size = 'm',
  block = false,
  ...rest
}: Props) {
  const className = [styles.base, styles[size], styles[variant], block ? styles.block : '']
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" className={className} {...rest}>
      {children}
    </button>
  );
}
